import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiUrl } from '../enums/api-url.enum';
import { buildQueryParams } from '../helper-functions';

@Injectable({
  providedIn: 'root',
})
export class HttpService {
  private _url: string;

  public get getUrl(): string {
    return this._url;
  }

  constructor(private httpClient: HttpClient) {
    this._url = environment.apiLeagueServer;
  }

  public setApiUrl(api: ApiUrl): void {
    if (api === ApiUrl.FromBaymanager)
      this._url = environment.apiBaymanagerServer;
    else this._url = environment.apiLeagueServer;
  }

  public getItemByQuery<T>(
    api: ApiUrl,
    path: string,
    queryModel: any,
    apiVersion?: string,
  ): Observable<T> {
    this.setApiUrl(api);

    const url = this._url + path;
    let headers = new HttpHeaders();
    if (apiVersion) {
      headers = headers.set('X-Api-Version', apiVersion);
    }

    return this.httpClient
      .get<T>(url, {
        headers: headers,
        params: buildQueryParams(queryModel),
      })
      .pipe((res) => {
        const p = res || null;
        return p;
      });
  }

  public postItemByQuery<T>(
    api: ApiUrl,
    path: string,
    queryModel: any,
    data: any = null,
    apiVersion?: string,
  ): Observable<T> {
    this.setApiUrl(api);

    const url = this._url + path;
    let headers = new HttpHeaders();
    if (apiVersion) {
      headers = headers.set('X-Api-Version', apiVersion);
    }

    return this.httpClient
      .post<T>(url, data, {
        headers: headers,
        params: buildQueryParams(queryModel),
      })
      .pipe((res) => {
        const p = res || null;
        return p;
      });
  }

  public getItems<T>(
    api: ApiUrl,
    path: string,
    apiVersion?: string,
  ): Observable<T> {
    this.setApiUrl(api);

    const url = this._url + path;
    let headers = new HttpHeaders();
    if (apiVersion) {
      headers = headers.set('X-Api-Version', apiVersion);
    }

    return this.httpClient.get<T>(url, { headers }).pipe((res) => {
      const p = res || null;
      return p;
    });
  }

  public getItemById<T>(
    api: ApiUrl,
    id: any,
    path: string,
    apiVersion?: string,
  ): Observable<T> {
    this.setApiUrl(api);

    const url = this._url + path + `\\${id}`;
    let headers = new HttpHeaders();
    if (apiVersion) {
      headers = headers.set('X-Api-Version', apiVersion);
    }

    return this.httpClient.get<T>(url, { headers }).pipe((res) => {
      const p = res || null;
      return p;
    });
  }

  public createItem<T>(
    api: ApiUrl,
    data: any,
    path: string,
    apiVersion?: string,
  ): Observable<T> {
    this.setApiUrl(api);

    const url = this._url + path;
    let headers = new HttpHeaders();
    if (apiVersion) {
      headers = headers.set('X-Api-Version', apiVersion);
    }

    return this.httpClient.post<T>(url, data, { headers }).pipe((res) => {
      const p = res || null;
      return p;
    });
  }

  public updateItem<T>(
    api: ApiUrl,
    data: any,
    path: string,
    apiVersion?: string,
  ): Observable<T> {
    this.setApiUrl(api);

    const url = this._url + path;
    let headers = new HttpHeaders();
    if (apiVersion) {
      headers = headers.set('X-Api-Version', apiVersion);
    }

    return this.httpClient.put<T>(url, data, { headers }).pipe((res) => {
      const p = res || null;
      return p;
    });
  }

  public removeItem<T>(
    api: ApiUrl,
    data: any,
    path: string,
    apiVersion?: string,
  ): Observable<T> {
    this.setApiUrl(api);

    const url = this._url + path;
    let headers = new HttpHeaders();
    if (apiVersion) {
      headers = headers.set('X-Api-Version', apiVersion);
    }

    return this.httpClient
      .delete<T>(url, {
        headers: headers,
        params: {
          ...data,
        },
      })
      .pipe((res) => {
        const p = res || null;
        return p;
      });
  }

  public removeItemFromBody(
    api: ApiUrl,
    data: any,
    path: string,
    apiVersion?: string,
  ): Observable<any> {
    this.setApiUrl(api);

    const url = this._url + path;
    let headers = new HttpHeaders();
    if (apiVersion) {
      headers = headers.set('X-Api-Version', apiVersion);
    }

    return this.httpClient
      .delete<any>(url, { headers: headers, body: data })
      .pipe((res) => {
        const p = res || null;
        return p;
      });
  }
}
